import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html'
})
export class FaqComponent implements OnInit {
    constructor() { }

    ngOnInit() {
    	window.scrollTo(0,0);
    }
}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/additional-pages/faq/faq.component.ts